<template>
    <a-modal
        id="storyList-modal"
        :title="$t('chatbotv2.integrateStoryWithSupsisWidget')"
        wrapClassName="vertical-center-modal"
        :visible="modalVisible"
        @visibleChange="(isVisible) => $emit('modal-visible2', isVisible)"
        :footer="null"
        @cancel="handleCancel()"
    >
        <a-form class="d-flex flex-column justify-content-center" @submit.prevent="handleSave">
            <a-form-item
                :label="$t('chatbotv2.selectIntegratingStory')"
                :fieldDecoratorOptions="{
                    rules: [{ required: true, message: $t('chatbotv2.integrateStoryWithSupsisWidget') }],
                }"
            >
                <a-select v-model="selectedStory" @change="handleChange">
                    <a-select-option :key="story.id" v-for="story in stories" :value="story.id"
                    >{{ story.title }}
                    </a-select-option>
                </a-select>
            </a-form-item>
        </a-form>
        <div class="d-flex flex-row justify-content-between">
            <div class="d-flex flex-row justify-content-start">
                <a-button type="danger" v-if="!!selectedStory" @click="revokeDefault()">
                    <span> <a-icon type="api" class="px-1" /></span>{{ $t("chatbotv2.uninstall") }}
                </a-button>
            </div>
            <div class="d-flex flex-row justify-content-end">
                <a-button class="mr-1 ant-btn-primary" @click="handleOk()" :disabled="!isChangedStory">
                    {{ $t("chatbotv2.install") }}
                </a-button>
                <a-button class="ml-1" @click="handleCancel()">{{ $t("message.cancel") }}</a-button>
            </div>
        </div>
    </a-modal>
</template>

<script>
import confetti from 'canvas-confetti';
import { mapActions, mapState } from "vuex";
import _ from "lodash";

export default {
    name: "SelectStory",
    props: {
        modalVisible: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        ...mapState({
            stories: (state) => state.CB.stories,
            webChatChannel: (state) => state.channel.channels.find((channel) => channel.type === "webchat"),
        }),
    },
    data() {
        return {
            selectedStory: undefined,
            isChangedStory: false,
        };
    },
    methods: {
        ...mapActions({
            listStories: "CB/listStories",
            makeDefaultStory: "CB/makeDefaultStory",
            revokeDefaultStory: "CB/revokeDefaultStory",
            updateChannel: "channel/updateChannel",
        }),
        getCurrentSelectedStory() {
            let selectedStory = _.get(
                this.stories.find((x) => _.get(x, "integrations.supsisWidget")),
                "id",
            );
            if (!selectedStory && this.webChatChannel?.forward?.story) {
                selectedStory = this.stories.find((x) => x.id === this.webChatChannel.forward.story)?._id;
            }
            return selectedStory;
        },
        runSuccessConfetti() {
            const end = Date.now() + (3 * 1000); // 3 saniye
            const colors = ['#bb0000', '#ffffff'];

            const frame = () => {
                confetti({
                    particleCount: 2,
                    angle: 60,
                    spread: 55,
                    origin: { x: 0 },
                    colors: colors
                });
                confetti({
                    particleCount: 2,
                    angle: 120,
                    spread: 55,
                    origin: { x: 1 },
                    colors: colors
                });

                if (Date.now() < end) {
                    requestAnimationFrame(frame);
                }
            };

            frame();
        },
        handleSave() {
            if (!this.selectedStory) return;
            const webChatChannel = this.webChatChannel;
            this.updateChannel({
                ...webChatChannel,
                forward: {
                    ...webChatChannel.forward,
                    mode: "chatbot",
                    story: this.selectedStory,
                },
            }).then(() => {
                this.runSuccessConfetti();
            });
            this.$emit("modal-visible", false);
            this.isChangedStory = false;
        },
        reset() {
            this.selectedStory = null;
            this.isChangedStory = false;
        },
        handleOk() {
            this.handleSave();
        },
        handleCancel() {
            this.$emit("modal-visible", false);
            if (this.isChangedStory === true) {
                this.selectedStory = this.getCurrentSelectedStory();
                this.isChangedStory = false;
            }
        },
        handleChange() {
            this.isChangedStory = true;
        },
        revokeDefault() {
            const webChatChannel = this.webChatChannel;
            this.updateChannel({
                ...webChatChannel,
                forward: {
                    ...webChatChannel.forward,
                    mode: "live",
                    story: null,
                },
            }).then(() => {
                this.runSuccessConfetti();
            });
            this.$emit("modal-visible", false);
            this.reset();
        },
    },
    mounted() {
        this.listStories();
    },
    watch: {
        stories: {
            handler() {
                this.selectedStory = this.getCurrentSelectedStory();
            },
            deep: true,
        },
    },
};
</script>

<style lang="scss">
.vertical-center-modal {
    text-align: center;
    white-space: nowrap;
}

.vertical-center-modal:before {
    content: "";
    display: inline-block;
    height: 100%;
    vertical-align: middle;
    width: 0;
}

.vertical-center-modal .ant-modal {
    display: inline-block;
    vertical-align: middle;
    top: 0;
    text-align: left;
}
</style>
